import { render } from "./ListeModele.vue?vue&type=template&id=35fd1876&ts=true"
import script from "./ListeModele.vue?vue&type=script&lang=ts"
export * from "./ListeModele.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__